import { render, staticRenderFns } from "./SpecialProductMessageBox.vue?vue&type=template&id=7bdeff04&scoped=true"
import script from "./SpecialProductMessageBox.vue?vue&type=script&lang=js"
export * from "./SpecialProductMessageBox.vue?vue&type=script&lang=js"
import style0 from "./SpecialProductMessageBox.vue?vue&type=style&index=0&id=7bdeff04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdeff04",
  null
  
)

export default component.exports